import { Pipe, PipeTransform } from '@angular/core';
import { TaskDetailsM, TaskDetailsResponseM } from '../models/task/task-details.model';
import { TaskType } from '../enums/task.enum';

@Pipe({
  name: 'filterTaskOptions'
})
export class FilterTaskOptionsPipe implements PipeTransform {

  transform(taskOptions: any[], taskDetails: TaskDetailsM, appUserId: number,sharedTaskUsers: any[], taskTypeId: TaskType): any[] {

    if (!taskOptions || !appUserId || !taskDetails) {
      return [];
    }

    const isCreator = !!(appUserId === taskDetails.createdBy);
    const isReAssignedTo = !!(appUserId === taskDetails?.reAssignedTo);
    let isAssignedTo = !!(appUserId === taskDetails.taskUsers);
    isAssignedTo = (isCreator || isReAssignedTo) ? false : isAssignedTo;

    let isSharedUser = sharedTaskUsers?.some(user => user.id === appUserId);
    isSharedUser = (isCreator || isAssignedTo || isReAssignedTo) ? false : isSharedUser; //Check actual shared permission

    if((taskDetails.taskTypeId !== TaskType.Individual && taskDetails.taskTypeId !== TaskType.GroupChildTask) || isSharedUser){
        taskOptions = taskOptions.filter(option => option.code!='sub-task' );
    }
    // taskDetails?.reAssignedTo || 
    if(isSharedUser){
        taskOptions = taskOptions.filter(option => option.code!='re-assign' );
    }

    if (taskDetails.isCompleted) {
      taskOptions = taskOptions.filter(option => option.code === 'comment');
    }

    return taskOptions;
  }
}
